import { LitElement, css, html } from 'lit';

import { StateController } from '../helpers/state/state-management/state-controller';
import { customElement } from 'lit/decorators';
import { getCategoryIcon } from '../helpers/markers';
import topicData from '../helpers/state/topic-data';

@customElement('legend-component')
export class LegendComponent extends LitElement {

    private readonly bindTopicState = new StateController(this, topicData);

    render() {
        return html`
            <paper-listbox class="container">
                ${topicData.categories.map(
                    (c) => html`
                        <paper-item class="short" title="${c.description}">
                            <paper-item-body class="short" two-line>
                                <div>
                                    <img
                                        class="categoryTitleImage"
                                        src="${getCategoryIcon(c._id)}"
                                        alt=""
                                    />&nbsp;${c.name}
                                </div>
                                <div class="small" secondary>${c.description}</div>
                            </paper-item-body>
                        </paper-item>
                    `
                )}
            </paper-listbox>
        `;
    }

    static get styles() {
        return css`
            .container {
                pointer-events: none;
                user-select: none;
            }

            .short {
                min-height: 10px;
            }

            .small {
                font-size: 10px;
            }

            .categoryTitleImage {
                height: 24px;
                vertical-align: sub;
            }
        `;
    }
}
